import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import LoanHistory from "../components/LoanHistory";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHandHoldingDollar } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";

function Loanhistory() {
  const { user } = useUser();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [assethistory, setAssethistory] = useState([]);
  const [crypto, setCrypto] = useState([]);
  const [fiat, setFiat] = useState([]);
  const [stock, setStock] = useState([]);
  const [wallet, setWallet] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchwallet: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setWallet(data.wallet);
      }
    })
    .catch(err => {
      
    })
  }, [user]);
  useEffect(() => {
      fetch(`/coin_list.txt`)
      .then((res) => res.json())
      .then((data) => {
      var coinList = data.data;
      const updatedData = coinList.map((coin, index) => ({
          id: index + 1,
          logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
          name: coin.name,
          type: 'crypto',
          symbol: coin.symbol,
          price: Number(coin.quote.USD.price.toFixed(2)),
          amount: 0,
      }));
      setCrypto(updatedData);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    fetch(`/stock_list.txt`)
    .then((res) => res.json())
    .then((data) => {
    const stockList = Object.values(data);
    const updatedData = stockList.map((stock, index) => ({
        id: index + 1,
        logo: `https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`,
        name: stock.name,
        type: 'stock',
        symbol: stock.symbol,
        price: Number(stock.price.toFixed(2)),
        amount: 0,
    }));
    setStock(updatedData);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {   
      fetch(`/fiat_list.txt`)
      .then((res) => res.json())
      .then((data) => {
        const wantedCurrencies = {
          AUD: 'Australian Dollar',
          CAD: 'Canadian Dollar',
          CHF: 'Swiss Franc',
          CNY: 'Chinese Yuan',
          EUR: 'Euro',
          GBP: 'British Pound',
          INR: 'Indian Rupee',
          JPY: 'Japanese Yen',
          RUB: 'Russian Ruble',
          USD: 'US Dollar',
          ZAR: 'South African Rand'
        };
        const fiatList = Object.entries(data)
          .filter(([code]) => wantedCurrencies.hasOwnProperty(code))
          .map(([code, value], index) => ({
            id: index + 1,
            symbol: code,
            name: wantedCurrencies[code],
            price: Number(value),
            type: 'fiat',
            logo: `https://flagcdn.com/w40/${code.slice(0, 2).toLowerCase()}.png`,
            amount: 0,
          }));
        
        setFiat(fiatList);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    if (!crypto.length && !fiat.length && !stock.length) return;
    const walletMap = wallet.reduce((acc, item) => {
      const key = item.coinName?.trim().toLowerCase();
      acc[key] = parseFloat(item.balance) || 0;
      return acc;
    }, {});
    const applyWalletBalance = (list, categoryTotal) => {
      let categorySum = 0;
      const result = list.map(item => {
        const key = item.name?.trim().toLowerCase();
        const matchedBalance = walletMap[key];
        const amount = matchedBalance || 0;
        const value = amount * item.price;
        categorySum += value;
        return {
          ...item,
          amount: matchedBalance || 0
        };
      });
      return { result, categorySum };
    };
    const { result: cryptoWithBalance } = applyWalletBalance(crypto);
    const { result: fiatWithBalance } = applyWalletBalance(fiat);
    const { result: stockWithBalance } = applyWalletBalance(stock);
    const merged = [
      ...cryptoWithBalance,
      ...fiatWithBalance,
      ...stockWithBalance
    ];
    const sorted = merged.sort((a, b) => {
      if (b.amount > 0 && a.amount === 0) return 1;
      if (a.amount > 0 && b.amount === 0) return -1;
      return a.name.localeCompare(b.name);
    });
    setAssethistory(sorted);
  }, [crypto, fiat, stock, wallet]);
  const [allLoan, setAllLoan] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchloan: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        //active loan
        const updatedSavings1 = data.allloan.map(tx => {
          let logo = null;
          let symbol = null;
          let c_symbol = null;
          let c_logo = null;
          const asset = assethistory.find(asset => asset.name === tx.method);
          if (asset) {
            logo = asset.logo;
            symbol = asset.symbol;
          }
          const asset1 = assethistory.find(asset => asset.name === tx.collateral_method);
          if (asset1) {
            c_logo = asset1.logo;
            c_symbol = asset1.symbol;
          }
          return {
            ...tx,
            logo,
            symbol,
            c_symbol,
            c_logo,
          };
        });
        setAllLoan(updatedSavings1);
      }
    })
    .catch(err => {
    })
  }, [user, assethistory]);

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Loan History" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Loan History" icon={<FontAwesomeIcon icon={faHandHoldingDollar} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="row">
                <div className="col-12">
                    <h5 className="fw-bold mb-4 mt-3">Loan History</h5>
                    <div className="mycard mt-2 mb-4">
                        <p className="fw-semibold text-secondary mb-2">My Loans ({allLoan.length})</p>
                        <div className="table-responsive">
                            <table className="table table-borderless table-dark align-middle">
                                {allLoan.length > 0 ? (
                                    allLoan.map((loan, index) => (
                                    <>
                                        <thead>
                                            <tr className="fs-7">  
                                                <th className="fw-normal text-secondary pb-0 d-md-table-cell d-none"></th>
                                                <th className="fw-normal text-secondary pb-0 text-nowrap">Total Debt ({loan.symbol})</th>
                                                <th className="fw-normal text-secondary pb-0 text-nowrap d-lg-table-cell d-none">Collateral Amount ({loan.c_symbol})</th>
                                                <th className="fw-normal text-secondary pb-0 text-nowrap d-lg-table-cell d-none">Residual Interest ({loan.symbol})</th>
                                                <th className="fw-normal text-secondary pb-0 text-nowrap">Rate</th>
                                                <th className="fw-normal text-secondary pb-0 text-nowrap d-md-table-cell d-none">Remaining Principal ({loan.symbol})</th>
                                                <th className="fw-normal text-secondary pb-0 text-nowrap d-lg-table-cell d-none">Date Started</th>
                                                <th className="fw-normal text-secondary pb-0 text-nowrap d-lg-table-cell d-none">Expired Date</th>
                                                <th className="fw-normal text-secondary pb-0">Status</th>
                                                <th className="fw-normal text-secondary pb-0 d-md-table-cell d-none"></th>
                                                <th className="fw-normal text-secondary pb-0 d-lg-table-cell d-none"></th>
                                            </tr>
                                        </thead>
                                        <tbody style={{fontSize: '14px'}}>
                                            <LoanHistory index={index} loan={loan}/>
                                            <tr>
                                                <td className="p-0" colSpan={10}><hr className="my-0"/></td>
                                            </tr>
                                        </tbody>
                                    </>
                                    )) 
                                    ) : (
                                    <tbody style={{fontSize: '14px'}}>
                                        <tr>
                                            <td colSpan={5}>No loan records yet.</td>
                                        </tr>
                                    </tbody>
                                )}
                            </table>
                        </div>
                    </div>
                </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Loanhistory